(() => {
  'use strict';
  const calendarDay = (date, zone = 'Europe/Paris') => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date).map(part => [part.type, part.value]));
    return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
  };
  const daysUntil = (target, now = new Date()) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(target || '')) return null;
    const [year, month, day] = target.split('-').map(Number);
    const time = Date.UTC(year, month - 1, day);
    const checked = new Date(time);
    if (checked.getUTCFullYear() !== year || checked.getUTCMonth() !== month - 1 || checked.getUTCDate() !== day) return null;
    return Math.round((time - calendarDay(now)) / 86400000);
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { calendarDay, daysUntil };
  if (typeof document === 'undefined') return;
  const update = () => {
    for (const node of document.querySelectorAll('[data-cto-ramadan-countdown]')) {
      const days = daysUntil(node.dataset.target);
      const output = node.querySelector('[data-cto-ramadan-days]');
      if (days !== null && days > 0 && output) {
        output.textContent = node.dataset.label.replace('{days}', String(days));
        node.hidden = false;
      } else node.hidden = true;
    }
    for (const node of document.querySelectorAll('[data-cto-ramadan-season]')) {
      const end = daysUntil(node.dataset.end);
      if (end !== null && end < 0) node.hidden = true;
    }
  };
  update();
  document.addEventListener('click', event => {
    const link = event.target.closest('.cto-ramadan-portal a[href^="#"]');
    if (!link) return;
    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;
    const heading = target.querySelector('h2, h3') || target;
    if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
    requestAnimationFrame(() => {
      heading.focus({preventScroll: true});
      target.scrollIntoView({block: 'start', behavior: 'instant'});
    });
  });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  setInterval(update, 60000);
})();
